//@ts-nocheck
import moment from "moment-business-days";
const fedHolidays = require("@18f/us-federal-holidays");

const options = { shiftSaturdayHolidays: true, shiftSundayHolidays: true };

function getUsBankHolidays(startYear, endYear) {
  let allBankHolidays = [];

  for (let year = startYear; year <= endYear; year++) {
    const hds = fedHolidays.allForYear(year, options);
    allBankHolidays = [...allBankHolidays, ...hds.map((holiday) => holiday.dateString)];
  }

  return allBankHolidays;
}

const holidays = getUsBankHolidays(2025, 2035);

moment.updateLocale("us", {
  holidays: holidays,
  holidayFormat: "YYYY-MM-DD",
});

export function calculateWorkingDays(startDateStr, endDateStr) {
  const startDate = moment(startDateStr, "YYYY-MM-DD").startOf("day");
  const endDate = moment(endDateStr, "YYYY-MM-DD").startOf("day");
  if (!startDate.isValid() || !endDate.isValid()) {
    return "Invalid date format";
  }
  return startDate.businessDiff(endDate);
}

export function getCalendarDateFromBusinessDays(startDate, businessDays) {
  const startMoment = moment(startDate, "YYYY-MM-DD").startOf("day");
  if (!startMoment.isValid() || isNaN(businessDays)) {
    return "Invalid date or business days input";
  }

  const resultMoment = startMoment.businessAdd(businessDays);
  const totalCalendarDays = resultMoment.diff(startMoment, "days");
  return {
    resultDate: resultMoment.toDate(),
    totalCalendarDays: totalCalendarDays,
  };
}

export function formatServerDate(date) {
  if (!date) return "";

  if (date.toString().length === 10 && date.toString().indexOf("-") > -1) {
    return date;
  }

  let newDate = new Date(date);
  let dd = newDate.getDate();
  let mm = newDate.getMonth() + 1; 
  let yyyy = newDate.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }

  newDate = yyyy + "-" + mm + "-" + dd;
  return newDate;
}

export const convertTo12HourFormat = (time) => {
  const [hour, minute] = time.split(":");
  const period = hour >= 12 ? "PM" : "AM";
  const adjustedHour = hour % 12 || 12;
  return `${adjustedHour}:${minute} ${period}`;
};

export function formatMonthYearToInput(value: string): string {
  if (!value) return "";
  const m = moment(value, "MMMM YYYY", true);
  return m.isValid() ? m.format("YYYY-MM") : "";
}

export function formatToMMDDYY(input: any): string {
  if (input == null || input === "") return "";

  let m: moment.Moment;

  if (typeof input === "number") {
    const ms = input < 1e12 ? input * 1000 : input;
    m = moment(ms);
  } else if (typeof input === "string") {
    const s = input.trim();

    if (/^\d+$/.test(s)) {
      const num = Number(s);
      const ms = s.length <= 10 ? num * 1000 : num;
      m = moment(ms);
    } else {
      m = moment(s);
    }
  } else if (input instanceof Date) {
    m = moment(input);
  } else {
    m = moment(input);
  }

  return m.isValid() ? m.format("MM-DD-YY") : "";
}
